import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { LanguageSwitcher } from "@/components/common";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t } = useTranslation();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  const [email, setEmail] = useState(""), [password, setPassword] = useState("");
  const [err, setErr] = useState(""), [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try { await login(email, password); toast.success(t("Welcome back")); nav(next || "/dashboard"); }
    catch (e2) { setErr(formatApiError(e2.response?.data?.detail) || e2.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="flex justify-end mb-4"><LanguageSwitcher /></div>
        <Link to="/" className="font-display font-extrabold text-2xl tracking-tight text-primary block text-center mb-8">Deliber<span className="text-secondary">.</span>Act</Link>
        <div className="border border-border bg-white p-8">
          <h1 className="font-display text-2xl font-bold tracking-tight mb-6">{t("Log in")}</h1>
          <form onSubmit={submit} className="space-y-4">
            <div><label className="overline block mb-1">{t("Email")}</label><input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={ic} /></div>
            <div><label className="overline block mb-1">{t("Password")}</label><input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={ic} /></div>
            {err && <p data-testid="login-error" className="text-sm text-destructive">{err}</p>}
            <button data-testid="login-submit" disabled={busy} className="w-full bg-primary text-white py-2.5 rounded-sm font-semibold hover:bg-primary/90 transition-colors disabled:opacity-60">{busy ? t("Signing in…") : t("Log in")}</button>
          </form>
          <div className="mt-4 text-center">
            <Link to="/forgot-password" data-testid="login-forgot" className="text-sm text-primary font-semibold">{t("Forgot your password?")}</Link>
          </div>
          <p className="text-sm text-muted-foreground mt-6 text-center">{t("No account?")} <Link to="/register" className="text-primary font-semibold">{t("Register")}</Link></p>
        </div>
      </div>
    </div>
  );
}
const ic = "w-full border border-border bg-background rounded-sm px-3 py-2 focus:ring-2 focus:ring-primary/50 focus:border-primary outline-none";
